import React from 'react';
import './style.css';
import Logo from './Logo'

interface Section {
  displayName: string;
  addressLines: string[];
  phone: string;
  phone2?: string;
  fax?: string;
  email: string;
}

interface Props {
  name: string;
  position: string;
  role1: string;
  role2: string;
  phonePrivate?: string;
  section: Section;
}

const SignaturePreview: React.FC<Props> = ({
  name,
  position,
  role1,
  role2,
  phonePrivate,
  section,
}) => {
  return (
    <div className="border p-4 rounded bg-light lttext">
      <p>Mit freundlichen Grüßen</p>
      <strong>{name || 'Ihr Name'}</strong>
      <br />
      {position && (
        <>
          <span>{position}</span>
        </>
      )}
      <br />
      <br />
      {role1 && (
        <>
          <span>{role1}</span>
          <br />
        </>
      )}
      {role2 && (
        <>
          <span>{role2}</span>
          <br />
        </>
      )}
      <br />
      <Logo width={250} />
      <br />
      <br />
      <strong>Laterna.Tech</strong>
      <br />
      <strong>{section.displayName}</strong>
      <br />
      <br />
      {section.addressLines.map((line, idx) => (
        <React.Fragment key={idx}>
          {line}
          <br />
        </React.Fragment>
      ))}
      <br />
      <span>
        Telefon:{' '}
        <a className="ltlink" href={`tel:${section.phone.replace(/[^+\d]/g, '')}`}>
          {section.phone}
        </a>
      </span>
      <br />
      {section.phone2 && (
        <>
          <span>
        Telefon 2:{' '}
        <a className="ltlink" href={`tel:${section.phone2.replace(/[^+\d]/g, '')}`}>
          {section.phone2}
        </a>
      </span>
          <br />
        </>
      )}
      {phonePrivate && (
        <>
          <span>
        Telefon (privat):{' '}
        <a className="ltlink" href={`tel:${phonePrivate.replace(/[^+\d]/g, '')}`}>
          {phonePrivate}
        </a>
      </span>
          <br />
        </>
      )}
      {section.fax && (
        <>
          <span>
            Fax:{' '}
            <a className="ltlink" href={`tel:${section.fax.replace(/[^+\d]/g, '')}`}>
              {section.fax}
            </a>
          </span>
          <br />
        </>
      )}
      <span>
        E-Mail:{' '}
        <a className="ltlink" href={`mailto:${section.email}`}> {section.email}</a>
      </span>
      <br />
      <a className="ltlink" href="https://laterna.tech/" target="_blank">
        https://laterna.tech/
      </a>
      <p className="mt-3" style={{ fontFamily: 'Arial, sans-serif', fontSize: '8px' }}>
        <b>Pflichtinformationen gemäß Artikel 13 DSGVO:</b>
        <br />
        Im Falle des Erstkontakts ...
      </p>
    </div>
  );
};

export default SignaturePreview;